export const COLORS = Object.freeze({
    "POLKADOT": "#E6007A",
    "KUSAMA": "#4E4E4E",
    "YELLOW": "#FCD34D",
    "RED": "#EF4444",
    "GREEN": "#10B981"
})
